import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { formatBookingObject } from '../other/sharedFunctions';
import { get, onValue, push } from "firebase/database";

function firstWord(str) {
  if (!str || typeof str !== 'string') return '';
  return str.trim().split(' ')[0];
}

function buildBookingTitle(booking) {
  if (!booking.tripdate) return 'Neue Fahrt';

  const d = new Date(booking.tripdate);

  const date = d.toLocaleDateString('de-AT', {
    day: '2-digit',
    month: 'short',
  });

  const time = d.toLocaleTimeString('de-AT', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return `Abfahrt ${date} ${time}h`;
}

function buildBookingMsg(booking) {
  const pickup =
    booking.pickupAddress ||
    (booking.pickup && booking.pickup.add) ||
    '';

  const drop =
    booking.dropAddress ||
    (booking.drop && booking.drop.add) ||
    '';

  const price =
    booking.trip_cost != null
      ? Number(booking.trip_cost).toFixed(2) + ' €'
      : null;

  const distance =
    booking.totalDistance != null
      ? Number(booking.totalDistance).toFixed(1) + ' km'
      : null;

  let msg = `${firstWord(pickup)} → ${firstWord(drop)}`;

  if (price) msg += ` | ${price}`;
  if (distance) msg += ` | ${distance}`;

  return msg;
}

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const {
        bookingRef,
        settingsRef,
        singleUserRef
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();

    let data = await formatBookingObject(bookingData, settings);
    const title = buildBookingTitle(data);
const msg = buildBookingMsg(data);

    // Get the drivers to notify - check both requestedDrivers AND preRequestedDrivers
    const driversToNotify = bookingData.requestedDrivers || bookingData.preRequestedDrivers;

    if (driversToNotify && Object.keys(driversToNotify).length > 0) {
        const soundFile = settings.CarHornRepeat ? 'repeat' : 'horn';
        const channelId = settings.CarHornRepeat ? 'repeat' : 'horn';

        Object.keys(driversToNotify).map((uid) => {
            onValue(singleUserRef(uid), snapshot => {
                if (snapshot.val()) {
                    const pushToken = snapshot.val().pushToken;
                    const platform = snapshot.val().userPlatform ?  snapshot.val().userPlatform. toLowerCase() : 'unknown';
                    const isAndroid = platform === 'android';
                    const isIOS = platform === 'ios';
                    let iosSound = 'default';
      if (soundFile !== 'default' && isIOS) {
        soundFile = soundFile.endsWith('.wav') ? soundFile : soundFile + '.wav';
      } 
                    if (pushToken) {
                        RequestPushMsg(
                            pushToken,
                            {
                                title: title,
msg: msg,
screen: 'Reservierungen',
                                sound: (isIOS || isAndroid) ? soundFile : 'default',
                                channelId: isAndroid ? channelId : undefined,
                                priority: 'high',
                            });
                    }
                }
            }, { onlyOnce: true });
            return driversToNotify[uid];
        });
    }

    push(bookingRef, data).then((res) => {
        var bookingKey = res.key;
        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: bookingKey,
                mainData: {
                    ...data,
                    id: bookingKey
                }
            }
        });
    }).catch(error => {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error. code + ":  " + error.message,
        });
    });
};